"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EQualiteRepresentant = void 0;
exports.EQualiteRepresentant = {
    president: "president",
    gerant: "gerant",
    signataire: "signataire",
};
